<template>
  <div class="total-info-wrap">
    <span>申报总人数：{{ totalInfo.totalRS }}</span>
    <span>收入总额：{{ totalInfo.Answer_CurrentIncome }}</span>
    <span>应纳税额：{{ totalInfo.Answer_TaxCreditPayable }}</span>
    <span>应补退税额：{{ totalInfo.Answer_TaxCreditPayable }}</span>
  </div>
</template>

<script setup>
//个税3个题，合计的数据信息
import Big from "big.js";

const totalInfo = reactive({
  totalRS: 0,
  Answer_CurrentIncome: '0.00',
  Answer_TaxCreditPayable: '0.00',
})

const props = defineProps({
  currentAns: {
    type: Array,
    required: true,
  }
})

const currentQa = inject('provideCurrentQa');
const allQaList = inject('provideAllQa');


onMounted(() => {
  // 比当前题号小的其他的个税题
  const otherPersonTaxQa = allQaList.value.filter(f => f.queType == '5' && f.queNo < currentQa.value.queNo)


  // 所有比当前小题目的用户答案
  let allUserAnswer = []
  otherPersonTaxQa.forEach(qa => {
    allUserAnswer = allUserAnswer.concat(JSON.parse(qa.solution)?.userAnswer || [])
  })
  allUserAnswer = allUserAnswer.concat(props.currentAns)


  let Answer_CurrentIncome = new Big(0), Answer_TaxCreditPayable = new Big(0)
  allUserAnswer.forEach(an => {
    Answer_CurrentIncome = Answer_CurrentIncome.plus(an.Answer_CurrentIncome || 0)
    Answer_TaxCreditPayable = Answer_TaxCreditPayable.plus(an.Answer_TaxCreditPayable || 0)
  })
  totalInfo.totalRS = allUserAnswer.length
  totalInfo.Answer_CurrentIncome = Answer_CurrentIncome.toFixed(2)
  totalInfo.Answer_TaxCreditPayable = Answer_TaxCreditPayable.toFixed(2)
})
</script>

<style scoped lang="scss">
.total-info-wrap {
  color: #979494;

  span {
    margin-left: 6px;
  }
}
</style>
